module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "Joinbanner"
  }, [_c('div', {
    staticClass: "MethodsBanner"
  }, [_c('img', {
    staticClass: "MethodsPic",
    attrs: {
      "src": require("../assets/MethodsBanner.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center-title"
  }, [_c('h4', [_vm._v("商务合作")]), _vm._v(" "), _c('p', [_vm._v("Business Cooperation")]), _vm._v(" "), _c('div', {
    staticClass: "blueLine"
  }), _vm._v(" "), _c('div', {
    staticClass: "greyLine"
  })]), _vm._v(" "), _c('div', {
    staticClass: "product"
  }, [_c('div', {
    staticClass: "coffee"
  }, [_c('img', {
    staticClass: "coffeePic",
    attrs: {
      "src": require("../assets/coffee.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "word coffeeWord"
  }), _vm._v(" "), _c('p', {
    staticClass: "words"
  }, [_vm._v("玛氏多功能咖啡机")])]), _vm._v(" "), _c('div', {
    staticClass: "chair"
  }, [_c('img', {
    staticClass: "chairPic",
    attrs: {
      "src": require("../assets/chair.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "word chairWord"
  }), _vm._v(" "), _c('p', {
    staticClass: "words"
  }, [_vm._v("九点商用按摩椅")])]), _vm._v(" "), _c('div', {
    staticClass: "machine"
  }, [_c('img', {
    staticClass: "machinePic",
    attrs: {
      "src": require("../assets/machine.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "word machineWord"
  }), _vm._v(" "), _c('p', {
    staticClass: "words"
  }, [_vm._v("抢红包礼品机")])]), _vm._v(" "), _c('div', {
    staticClass: "movie"
  }, [_c('img', {
    staticClass: "moviePic",
    attrs: {
      "src": require("../assets/movie.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "word movieWord"
  }), _vm._v(" "), _c('p', {
    staticClass: "words"
  }, [_vm._v("录音棚")])])]), _vm._v(" "), _c('div', {
    staticClass: "equip"
  }, [_c('div', {
    staticClass: "equipment"
  }, [_c('p', {
    staticClass: "titlen"
  }, [_vm._v("设备合作，免押金，入驻分成")])]), _vm._v(" "), _c('div', {
    staticClass: "equipmentPic"
  }, [_c('div', {
    staticClass: "data"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/data.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "wordd dataWord"
  }, [_vm._v("场地方递交资料")])]), _vm._v(" "), _c('img', {
    staticClass: "goleftPic",
    attrs: {
      "src": require("../assets/goleft.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "examine"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/examine.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "wordd examineWord"
  }, [_vm._v("公司审核")])]), _vm._v(" "), _c('img', {
    staticClass: "goleftPic2",
    attrs: {
      "src": require("../assets/goleft.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "equipp"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/equipp.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "wordd equippWord"
  }, [_vm._v("发放设备")])]), _vm._v(" "), _c('img', {
    staticClass: "goleftPic3",
    attrs: {
      "src": require("../assets/goleft.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "install"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/install.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "wordd installWord"
  }, [_vm._v("安装和售后服务")])]), _vm._v(" "), _c('img', {
    staticClass: "goleftPic4",
    attrs: {
      "src": require("../assets/goleft.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "divided"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/divided.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "wordd dividedWord"
  }, [_vm._v("月结分成")])])]), _vm._v(" "), _c('img', {
    staticClass: "cooperationButton",
    attrs: {
      "src": require("../assets/button3.png")
    }
  })]), _vm._v(" "), _c('div')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40894a6e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/methods.vue
// module id = 277
// module chunks = 1